import type { InstitutionTheme } from '../types';
import { unicColors } from './colors';

// University of Nicosia (UNIC, Cyprus) institutional theme — S3 (2026-10-14). Nicosia campus;
// UNIC Athens is deferred and would be its own institution (`unic-athens`).
//
// Names: "University of Nicosia" (site header, every policy document); short name "UNIC" (the
// logo wordmark, "UNIC Portal"). registrationPortalName VERIFIED first-party:
// onboarding/unic/probes/student_portal.txt ("UNIC Portal is a continuously growing gateway
// …"); on-line pre-registration runs through the portal (Academic Policies §2.14.2).
//
// Example course codes vetted against the S0 index (onboarding/unic/probes/course_index_s0.json):
// COMP-111 (Programming Principles I, CS BSc semester 1), ENGL-101 (English Composition, the
// Language Expression course in most programmes), BADM-231. First entry is the primary example.
export const unicTheme: InstitutionTheme = {
  slug: 'unic',
  universityName: 'University of Nicosia',
  universityShortName: 'UNIC',
  registrationPortalName: 'UNIC Portal',
  exampleCourseCodes: ['COMP-111', 'ENGL-101', 'BADM-231'],
  colors: unicColors,
};
